import {
  Box, Heading, Image, Link, Text,
} from '@domain-group/suit-theme'

import LogoMarkUrl from './assets/logo-mark.svg'

interface AccessDeniedProps {
  accountLocked?: boolean,
  callbacks: {
    logout: () => void,
  },
}

const AccessDenied = (props: AccessDeniedProps) => {
  const {
    accountLocked = false,
    callbacks: { logout },
  } = props

  const heading = accountLocked ? 'Account Inactive' : 'Access Denied'
  const message = accountLocked ? (
    <>
      We&apos;re sorry but your account is currently inactive or unavailable.
      If you believe this is an error please contact us on{' '}

      <Link href="mailto:support@realhub.com.au" textProps={{ marginTop: 'medium' }}>
        support@realhub.com.au
      </Link>
    </>
  ) : 'Sorry, you are not allowed past this point.'

  return (
    <Box
      alignItems="center"
      backgroundColor="whiteGrey"
      height="100vh"
      justifyContent="center"
      padding={['large', 'xxlarge']}
      width="100%"
    >
      <Box
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        lineHeight="1.3"
        textAlign="center"
        width={['100%', '400px']}
      >
        <Image backgroundSize="contain" url={LogoMarkUrl} width={50} height={50} />

        <Heading textProps={{ color: 'bodyFontLightColor', marginTop: 'xlarge' }}>
          {heading}
        </Heading>

        <Text fontSize="small" marginTop="xlarge">
          {message}
        </Text>

        <Box alignItems="center" fontSize="xsmall" justifyContent="center" marginTop="xxlarge">
          <Text color="bodyFontLightColor" marginRight="small">Not Loading?</Text>

          <Link onClick={() => logout()}>Try Another Account</Link>
        </Box>
      </Box>
    </Box>
  )
}

export default AccessDenied
